import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function J1() {
    const { useLang } = useGlobal();
    const { t } = useLang('vanliferoadtrips');

    return (
        <div id="vanlife-roadtrips-J" className={`vanlife-roadtrips-J1 ${css['vanlife-roadtrips-J1']}`}>
            <EcoImg
                pc="https://websiteoss.ecoflow.com/figma-uploads/1786690812907-evhn33-compressed-006.webp"
                h5="https://websiteoss.ecoflow.com/figma-uploads/1786690846289-am4ffb-compressed-006.webp"
                alt={t('secJ_title')}
                aria-label={t('secJ_title')}
            />
            <div className="info">
                <p className="title">{t('secJ_title')}</p>
                <p className="desc">{t('secJ_desc')}</p>
            </div>
        </div>
    );
}
